import DropDownMenu from "@/components/ComponentLibrary/DropDownMenu/dropdownMenu";
import { ROUTE_LOGIN_OUT } from "@/constants/routes.constants";
import { DropDownMenuItem } from "@/types";
import { User } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

const MainDropdown: React.FC = () => {
  const { t } = useTranslation();
  const nav = useNavigate();

  const menuItems: DropDownMenuItem[] = [
    // {
    //   label: t("Profile"),
    //   onClick: () => console.log("Profile clicked"),
    // },
    // {
    //   label: t("Settings"),
    //   onClick: () => console.log("Settings clicked"),
    // },
    // {
    //   label: t("Help"),
    //   subItems: [
    //     {
    //       label: t("FAQ"),
    //       onClick: () => console.log("FAQ clicked"),
    //     },
    //     {
    //       label: t("Contact Support"),
    //       onClick: () => console.log("Contact Support clicked"),
    //     },
    //   ],
    // },
    {
      label: t("Logout"),
      onClick: () => nav(ROUTE_LOGIN_OUT),
    },
  ];

  return (
    <div className="cursor-pointer justify-center">
      <DropDownMenu
        trigger={
          <div className="bg-primary flex h-8 w-8 cursor-pointer items-center justify-center overflow-hidden rounded-full text-white shadow">
            <User className="stroke-secondary" />
          </div>
        }
        items={menuItems}
      />
    </div>
  );
};

export default MainDropdown;
